/*
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-23 14:00:06
 * @Description: 
 */

import { defineStore } from 'pinia';
import type { JoinStateType } from '@/socket/game/dto/index.dto';
import { JoinState } from '@/socket/game/dto/index.dto';
import useSettingsStore from '~/stores/settings/index';
import {aCurrencyInUse} from '@/common/js/constant';
import {useGameHistoryStore} from './gameHistory';
import { getGameName } from '@/common/js/gameAbout';
import { oFailedShowDateInQ } from '@/common/js/gameJoining'; 


// 👇保存游戏信息，最大最小下注金额等
export const useJoinStateStore = defineStore('join', {
    state: () => ({
        ...JoinState,
    }),
    actions: {
        setState(partialState: JoinStateType) {
            const entries = Object.entries(partialState.config || {});
            const configFiltered:any = entries.reduce((oResult, current)=>{
                const [key, val] = current;
                if (val && (val.constructor.name === 'Object')){
                    let newVal = Object.assign({}, val) as any;                 
                    // ↓ 过滤掉没用的货币
                    var aa = aCurrencyInUse.includes(key);
                    var bb = Reflect.has(newVal, 'maxBets') === false;
                    if (aa || bb) oResult[key] = newVal;
                }else{
                    oResult[key] = val;
                }
                return oResult;
            }, {});
            partialState.config &&= configFiltered;
            // console.log("游戏信息(join) 已经更新", partialState);
            Object.assign(this, partialState);
        },
        // ↓ 显示延时的数据
        // ↓ 此方法偶尔执行失败，因为下注接口执行完毕后，将执行此方法用于插入早先接收到的历史记录数据
        // ↓ 但此时偶见游戏历史数据尚未下发的情况，所以执行失败（目前监测到有时2者间隔 600ms，但少有发生）
        // ↓ 下方的二参为解决这情况而设定 
        showDateInQueue(
            id='',
            isPatching=false, // 收到 true 表示这是在游戏开局前尝试把前一局扑空的数据插入一下，此为容错手段
        ){
            const gameHistoryStore = useGameHistoryStore();
            // 需要使用 findLast() 从后往前（因为后面的数据是先下注的） 
            const oTarget01 = this.history.all.findLast(cur=>{
                if (id) return id === String(cur._id);
                return cur.toDelay;
            });
            const oTarget02 = gameHistoryStore.historyData.response.findLast(cur=>{
                if (id) return id === String(cur._id);
                return cur.toDelay;
            });
            if (!oTarget01 || !oTarget02){
                // ↓ 二参为 true 时找不到也属于正常，在此 return; 
                if (isPatching) return;
                // ↓ 说明：通常在下注毕后执行此方法，将“早先收到的” 游戏结果显示出来
                // ↓ 但有时用户启动快速模式，没有播放动画就调用了此方法，此方法时尚未“收到”下发的游戏结果，导致显示游戏历史失败 
                // ↓ 在此记录“显示历史失败” 的信息，这样在游戏历史下发时会察觉“哦，刚才插入失败了” 那这条不必延时显示了 
                // ↓ 这个失败暂且定义为“扑空” 以后注释都为“扑空” 来形容，钦此 
                const sGame = getGameName();
                oFailedShowDateInQ[sGame] = Date.now();
                console.warn(`🚹 扑空事件：${sGame} - showDateInQueue() failed`, id);
            }else if (isPatching){
                console.log(`🚺 扑空事件补丁02 [已生效]; all, own 如下`);
                console.log(deepCopy(oTarget01), '\n', deepCopy(oTarget02));
            }
            if (oTarget01) oTarget01.toDelay = false;
            if (oTarget02) oTarget02.toDelay = false;
        },
        /**
         * 存储circle Bets Online数据
         * @param data 要存储的实时下注数据
         */
        setBetsOnline(data?){
            if (!data){
                this.betsOnline = [];
                console.log('circle 游戏已经清空本局下注玩家列表'); 
                return;
            }
            const oExistence = this.betsOnline.find(cur=>{
                return cur._id === data._id;
            });
            if (oExistence) {
                import.meta.dev && console.log('已拦截重复插入：', deepCopy(data)); 
                return; // 防止重复插入，因为真的会重复！！！ 
            }
            const onlines = [data, ...this.betsOnline ];
            this.betsOnline = onlines;
        },
        // ↓ 用于在游戏动画播放完毕后更新 jackpotDealy 触发界面变化 
        jackpotUpdate(iJackpot?:number){
            const newValue = (
                iJackpot >= 0
                ? iJackpot
                : (this.jackpot || 0)
            );
            this.jackpotDelay = newValue;
        },
    },
    getters: {
        getState: (state) => state,
        // ↓ 返回 true 表示当前游戏信息（下注上限值等）已经加载完毕
        hasGameInfoLoaded(state){
            // 这里的 state.gameName 只在当前游戏配置信息查询完毕后才会赋值 
            return !!state.gameName && (state.gameName === state.gameOfRoute);
        },
        // ↓ 表示当前游戏的历史记录是否已经加载完成
        hasGameHistoryLoaded(state){
            const hasLoaded = [
                state.gameId, // 进入游戏时此值会被赋值为 NaN
                state.gameName, // join 接口查询完毕后将赋值
                state.gameOfRoute, // 页面加载后路由中间件将为此赋值
                state.gameName === state.gameOfRoute,
            ].every(Boolean);
            return hasLoaded;
        },
        // ▼ 游戏的下注下限/上限/默认金额(当前币种)
        betttingLimits(state){
            const settinsStore = useSettingsStore();
            const oConfig = state.config[settinsStore.pickedCurrency];
            if (1 && import.meta.dev){
                console.log(`当前币种 ${settinsStore.pickedCurrency} 下注配置 ↓\n`, deepCopy(oConfig));
            }
            return oConfig || {};
        },
        // ↓ 可以显示的数据（排除了状态为“延时”的数据）—
        historyDelay(state){
            const {gameOfRoute} = state;
            const all = state.history.all?.filter((oCur) => {
                const check01 = !oCur.toDelay;
                let check02 = true; // 默认为 true，表示可显示
                if (gameOfRoute === 'hiloGame'){
                    check02 = oCur.status != 'play'; // 没结束不能显示
                }
                return check01 && check02;
            });
            return {
                ...state.history,
                all,
            };
        },
        betsOnlineData(state){
            return state.betsOnline;
        }
    },
});

